<template>
    <div>
        <head-nav></head-nav>
        <div class="form-pass">
            <img src="../../img/mission-logo.png" style="max-width:300px; margin-left: -11px">
            <br>
            <br>
            <span style=" font-family: 'lemon_milkregular';padding-top:15px;padding-bottom:15px">
                Please enter your new password.
            </span>
            <br>
            <br>
            <form class="login-form" @submit.prevent="changeOldPassword">
                <input name="password" placeholder="" type="password" autocomplete="new-password"
                    v-model="changePassword.password">
               <!--  <span class="al">Password must have at least 8 characters.</span> -->
                <button class="btn btn-dark" name="submit" type="submit">Submit</button>
            </form>
            <br>
            <a class="message" href="/home" style="font-family:berleno">Back to
                website</a>
        </div>
        <info></info>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import headNav from '../../components/navBar'
import info from '../../components/info';
import { auth } from '@/firebase';
import swal from 'sweetalert';
export default {
    components: {
        headNav,
        info
    },
    data() {
        return {
            token: ""
        }
    },
    methods: {
        async changeOldPassword() {
            const user = auth.currentUser;
            try {
                
                await user.updatePassword(this.changePassword.password).then(() => {
                    swal({
                        title: "Success",
                        text: "Your password was successfully changed",
                        icon: "success",
                        buttons: false,
                        timer: 3000
                    }).then(() =>{
                        this.$router.push('/home');
                    });
                })
            } catch (error) {
                swal({
                    title: "Error",
                    text: JSON.stringify(error.message),
                    icon: "error",
                    buttons: false,
                    timer: 3000,
                });
            }
        },
        ...mapActions('inPlayer', [
            //'ChangePassword'
        ])
    },
    computed: {
        ...mapState('inPlayer', [
            'changePassword',
            'inplayerId'
        ])
    },
}
</script>
<style>
.form-pass {
    position: relative;
    z-index: 1;
    background: #FFFFFF;
    max-width: 580px;
    max-height: 580px;
    margin: 20px auto 40px;
    padding: 45px;
    text-align: center;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
}

.form-pass input {
    font-family: 'berleno';
    outline: 0;
    background: #f2f2f2;
    width: 100%;
    border: 0;
    margin: 0 0 15px;
    padding: 15px;
    box-sizing: border-box;
    font-size: 14px;
}

.form-pass button {
    font-family: 'lemon_milkregular';
    text-transform: uppercase;
    outline: 0;
    width: 100%;
    border: 0;
    padding: 15px;
    color: #FFFFFF;
    font-size: 14px;
    -webkit-transition: all 0.3 ease;
    transition: all 0.3 ease;
    cursor: pointer;
}

.form-pass .message {
    margin: 5px 0 0;
    color: #212529;
    font-size: 15px;
    text-decoration: none;
}

.form-pass .al {
    margin: 15px 0 0;
    color: #212529;
    font-size: 11px;
    text-decoration: none;
}
</style>